module.exports = __webpack_public_path__ + "static/media/gamePlan_map.fb5560b0.webp";